export const cowTypes = {
  YoungBulls: 'Bulls for Breeding',
  Heifers: 'Heifers',
  BreedingCows: 'Cows for Breeding',
  FinishedCattle: 'Animals for Beef',
  Semen: 'Semen Straws',
  Embryos: 'Embryos'
};

export const getTextCowType = cowType => {
  try {
    return cowTypes[cowType];
  } catch (error) {
    return null;
  }
};

export const getCowTypeDropDownOptions = cowType => {
  return Object.keys(cowTypes).map(key => ({
    value: key,
    name: getTextCowType(key),
    selected: cowType === key
  }));
};
